import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {AuthenticationService, CookieService} from 'psd-common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'central-login-logout',
  templateUrl: 'central-login-logout.component.html'
})
export class CentralLoginLogoutComponent implements OnInit {
  private platformPrefix: string;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              private cookieService: CookieService,
              private router: Router) {
  }

  ngOnInit() {
    let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
    this.authenticationService.logout(environment, centralAccessToken).subscribe(() => {
      this.route.queryParams.subscribe(_params => {
        this.platformPrefix = _params.platform;
        this.router.navigate(['/central-login/login'], { queryParams: { 'platform' : this.platformPrefix }});
      });
    });
  }
}
